export const PER_PAGE = 20;
export const PER_PAGE_CACHE_THRESHOLD = PER_PAGE + 10;
export const BULK_MOVE_LIMIT = 1000;
